export default __webpack_public_path__ + "static/media/logo dog.4ca51014.svg";